<script setup lang="ts">
  import { computed, onBeforeMount, onBeforeUnmount  } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { storeToRefs } from 'pinia'
  
  import { Routes } from '@/const/Routes'
  import { useAuthStore } from '@/stores/auth'
  import { useTopic } from '@/composables/useTopic'
  import { PageTheme, useLayoutStore } from '@/stores/layout'

  import AppLayout from '@/components/layout/AppLayout.vue'
  import NavigateBackwardsLink from '@/components/layout/NavigateBackwardsLink.vue'
  import StandardLayout from '@/components/layout/Layout.vue'
  import SubjectResources from '@/components/SubjectResources.vue'
  import Typography from '@/components/common/Typography.vue'
  import VgsSpinner from '@/components/common/VgsSpinner.vue'

  const { t } = useI18n()
  const { isTeacher } = storeToRefs(useAuthStore())

  const { currentTopic, isLoading, subjectResources } = useTopic()

  const teacherSubjectResources = computed(() =>
    (subjectResources.value || [])
      .filter((subjectResource) => subjectResource.isTeacherOnly)
  )

  const { setTheme } = useLayoutStore()

  onBeforeMount(() => {
    setTheme(PageTheme.TeacherGuideTheme)
  })

  onBeforeUnmount(() => {
    setTheme(PageTheme.Default)
  })
</script>

<template>
  <StandardLayout v-if="isTeacher === true">
    <NavigateBackwardsLink :button-text="currentTopic?.title || ''" />
    <VgsSpinner :is-loading="isLoading" />
    <AppLayout>
      <div class="intro-wrapper">
        <Typography variant="h1">
          {{ t('teacherResourceBank.resource') }}
        </Typography>
        <Typography variant="preamble">
          {{ t('teacherResourceBank.summary') }}
        </Typography>
      </div>
      <template v-if="teacherSubjectResources?.length">
        <SubjectResources
          :title="t('topicPage.taskText')"
          :subject-resources="teacherSubjectResources"
          :link-route="Routes.TeacherResourceBankSubjectResource"
        />
      </template>
    </AppLayout>
  </StandardLayout>
</template>

<style scoped lang="scss">
  .intro-wrapper {
    max-width: 895px;
    margin-bottom: 96px;
  }
  </style>
